import api from "./api";

// api has baseURL = .../backend; use relative paths so baseURL is applied
const DEFECTS = "defects";

export const defectService = {
  list: async (params) => {
    const response = await api.get(DEFECTS, { params });
    return response.data;
  },

  exportCsv: async (params) => {
    const response = await api.get(`${DEFECTS}/export/csv`, {
      params,
      responseType: "blob",
    });
    return response;
  },

  get: async (id, params = {}) => {
    const response = await api.get(`${DEFECTS}/${id}`, { params });
    return response.data;
  },

  create: async (payload) => {
    const response = await api.post(DEFECTS, payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await api.patch(`${DEFECTS}/${id}`, payload);
    return response.data;
  },

  search: async (params) => {
    const response = await api.get(`${DEFECTS}/search`, { params });
    return response.data;
  },

  statusCounts: async (params) => {
    const response = await api.get(`${DEFECTS}/status-counts`, { params });
    return response.data;
  },

  duplicates: async (params) => {
    const response = await api.get(`${DEFECTS}/duplicates`, { params });
    return response.data;
  },

  sync: async () => {
    const response = await api.post(`${DEFECTS}/sync`);
    return response.data;
  },

  link: async (defectId, entityType, entityId, params = {}) => {
    const response = await api.post(`${DEFECTS}/${defectId}/link`, {
      entity_type: entityType,
      entity_id: entityId,
      ...params,
    });
    return response.data;
  },
};

export default defectService;
